import { useEffect, useState } from 'react';
import { MOBILE_BREAKPOINT_PX } from '@teo/widget-shared';
import { isMobileViewport } from './launcher-geometry.js';

/** Matches widget.css mobile sheet media query. */
export function useIsMobileViewport(
  breakpointPx: number = MOBILE_BREAKPOINT_PX,
): boolean {
  const [mobile, setMobile] = useState(() => isMobileViewport(breakpointPx));

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia(
      `(max-width: ${breakpointPx}px), (max-height: 500px) and (pointer: coarse)`,
    );
    const update = () => setMobile(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, [breakpointPx]);

  return mobile;
}
